export const GET_CONTENT_ELEMENTS = "GET_CONTENT_ELEMENTS";
export const REFRESH_CONTENT_ELEMENTS = "REFRESH_CONTENT_ELEMENTS";
export const RESET_CONTENT_ELEMENTS = "RESET_CONTENT_ELEMENTS";
export const SET_CONTENT_ELEMENTS_REQUEST_STATUS = "SET_CONTENT_ELEMENTS_REQUEST_STATUS";
export const DELETE_CONTENT_ELEMENTS = "DELETE_CONTENT_ELEMENTS";
